import React from 'react';
import Grid from "@mui/material/Grid";
import BillsEditable from './Tables/BillsEditable';
import { userInfo } from "../../../adalConfig";

const RetrainingBillsPage = (props) => {
    const [reload, setReload] = React.useState(false);
    const [user] = React.useState(userInfo());
    const userName = user?.userName || "";

    const reloadFunc = React.useCallback(() => {
        setReload((current) => !current);
    }, []);

    return (
        <Grid container spacing={3.5}>
            <Grid item xs={12}>
                <BillsEditable
                    workflowId="6"
                    userName={userName}
                    title="Retraining Bills"
                    access={props.access}
                    reloadFunc={reloadFunc}
                    reload={reload}
                    includeAIRetraining
                    aiRetrainingOnly
                    dashboard
                    summary
                />
            </Grid>
        </Grid>
    );
};

export default RetrainingBillsPage;